// Libs
import { useEffect, useRef } from 'react';
import { useDispatch } from 'resift';
import { connect } from 'react-redux';
import useRouter from '@sift/resift/useRouter';
import _get from 'lodash/get';
import hocify from 'hocify';
import compose from 'recompose/compose';

// Actions
import { toggleSupportDrawer } from 'store/support';
import {
  fetchAutocomplete,
  updateQuery,
  clearQuery,
  toggleBigSearch,
  closeBigSearch,
} from 'store/bigSearch';

import { fetchRecentSearches, updateRecentSearches } from 'store/search';

import { updateSettings } from 'store/settings';

// Models
import { Status } from '@sift/resift/models/Status';

import Component from './BigSearch';

/**
 * this watches the pathname and closes big search when the pathname changes
 */
const withCloseEffect = hocify(() => {
  const { location } = useRouter();
  const dispatch = useDispatch();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }

    dispatch(closeBigSearch());
  }, [dispatch, location.key]);

  return null;
});

const mapDispatchToProps = {
  toggleBigSearch,
  fetchAutocomplete,
  updateQuery,
  clearQuery,
  fetchRecentSearches,
  updateRecentSearches,
  updateSettings,
  toggleSupportDrawer,
};

const mapStateToProps = (state, ownProps) => {
  const initialStatus = new Status(
    state.bigSearch.fetchRecentSearchesStatus.value | state.bigSearch.fetchTeamStatus.value,
  );
  const team = state.bigSearch.team;

  return {
    recentSearches: state.bigSearch.recentSearches,
    renderToLayer: ownProps.renderToLayer || false,
    suggestions: state.bigSearch.suggestions || [],
    team,
    user: state.authentication.person,
    query: state.bigSearch.query,
    status: initialStatus,
    open: state.bigSearch.open,
    fields: state.configurations.user.fields,
    supportEnabled: _get(state.client.settings, 'support.enabled', false),
  };
};

export default compose(withCloseEffect, connect(mapStateToProps, mapDispatchToProps))(Component);
